export class URLHash
{
  static get( alternative:string = null )
  {
    let hash = window.location.hash;

    if ( ! hash )
    {
      return alternative;
    }

    if ( hash.startsWith( "#" ) )
    {
      hash = hash.substring( 1 );
    }

    return hash;
  }
}